import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ListSubheader from '@mui/material/ListSubheader';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import inlineStyles from './accountGroupStyles';

const AssocServicesDetails = (props) => {
	const {
		values,
		onSycurioUrlChange,
		errors,
	} = props;

	return (
		<div>
			<ListSubheader style={inlineStyles.subHeader}>
				<FormattedMessage {...messages.lbSycurioDetails} />
			</ListSubheader>

			<TextField
				id="sycurioUrl"
				label={<FormattedMessage {...messages.lbSycurioUrl} />}
				fullWidth
				value={values.sycurioUrl}
				onChange={onSycurioUrlChange}
				error={!!errors.srtSycurioUrl}
				helperText={errors.srtSycurioUrl}
				variant="standard"
			/>
		</div>
	);
};

AssocServicesDetails.propTypes = {
	values: PropTypes.object,
	onSycurioUrlChange: PropTypes.func.isRequired,
	errors: PropTypes.object,
};

export default AssocServicesDetails;
